import React, { useState, useEffect } from "react";
import { GoogleLogin } from "@react-oauth/google";
import logo from "../assets/logo.gif";
import "./SignIn.css";
import ScreenSize from "../screen-size/ScreenSize";
const SignIn = ({ onLoginSuccess, loginError, clearLoginError }) => {
  const [localLoginError, setLocalLoginError] = useState(null);
  const handleGoogleLogin = (response) => {
    if (response.credential) {
      setLocalLoginError(null);
      onLoginSuccess(response.credential);
    } else {
      setLocalLoginError("An error occurred. Please try again");
    }
  };useEffect(() => {
    let timer;
    if (localLoginError) {
      timer = setTimeout(() => {
        setLocalLoginError(null);
      }, 6000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [localLoginError]);
  useEffect(() => {
    let timer;
    if (loginError) {
      timer = setTimeout(() => {
        clearLoginError();
      }, 6000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [loginError, clearLoginError]);
  return (
    <div className="sign-in-out-cont">
      {localLoginError && <p className="error-message">{localLoginError}</p>}
      <img src={logo} alt="Logo" className="logo" />
      <h1>Welcome to Ram Thanganagai Maligai</h1>
       {/*  <button className='sign-in-button' onClick={handleGoogleLogin}>
        Sign in
      </button>   */}
      <div className="google-btn-wrapper">
       <GoogleLogin
        onSuccess={handleGoogleLogin}
        onError={() => setLocalLoginError("Google Login Failed. Please try again.")}
      /> 
      </div>
      <ScreenSize/>
    </div>
  );
};
export default SignIn;
